<script lang="ts" setup>
import placeholderUrl from '@/assets/images/product-placeholder.svg?url'
import { ref, watch } from 'vue'

const props = defineProps<{
  url?: string
  alt: string
}>()

const loadedImageUrl = ref<string | null>(null)

watch(
  () => props.url,
  () => {
    if (props.url) {
      const img = new Image()
      img.src = props.url
      img.onload = () => {
        loadedImageUrl.value = img.src
      }
      if (img.complete) {
        loadedImageUrl.value = img.src
      }
    }
  },
  { immediate: true },
)
</script>

<template>
  <transition name="ProductImage__Fade-" mode="out-in">
    <img
      v-if="loadedImageUrl"
      class="ProductImage"
      :src="url"
      :alt="alt"
      height="100"
      width="100"
    />
    <img
      v-else
      class="ProductImage"
      :src="placeholderUrl"
      :alt="alt"
      height="100"
      width="100"
    />
  </transition>
</template>

<style>
.ProductImage__Fade--enter-active,
.ProductImage__Fade--leave-active {
  transition: opacity 0.175s linear;
}

.ProductImage__Fade--enter-from,
.ProductImage__Fade--leave-to {
  opacity: 0;
}

.ProductImage img {
  object-fit: cover;

  &:-moz-loading {
    visibility: hidden;
  }
}
</style>
